import { Button, DefaultTooltipContent, Flex, Icon, Text } from "@theorgchartdev/storybook";
import { getFeatureAccess, getHoverTipContent } from "@/Utils/Misc";
import { getPlanPermissions } from "@/Utils/getPlanPermissions";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import { enumFeaturesList, enumPlanStatus } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const DashboardActions = props => {
  const { planMgr, wsMgr } = props;

  const { planManager } = usePlanManagerContext();
  const planStatus = planManager?.state?.GetPlanStatus();

  const { isPlanCollaborator } = getPlanPermissions({ useCurrentPlan: true });

  if (!isPlanCollaborator) {
    return null;
  }

  const isLocked = planStatus === enumPlanStatus.locked;
  const isArchived = planStatus === enumPlanStatus.archived;
  const isPlanDisabled = isLocked || isArchived;
  const isDisabled = isPlanDisabled || !getFeatureAccess(enumFeaturesList.refresh);

  let disabledTooltip = null;
  if (isLocked) {
    disabledTooltip = appstr("Locked plans cannot be synced with base chart data");
  } else if (isArchived) {
    disabledTooltip = appstr("Archived plans cannot be synced with base chart data");
  }

  const isConflicted = (() => {
    const conflictCount = planMgr.fTrackList?.GetFilteredObjectCount();
    const pickListMismatch = planMgr.GetPickListMismatch()
      ? planMgr.GetPickListMismatch().length
      : 0;

    return conflictCount + pickListMismatch > 0;
  })();

  const statusIcon = isConflicted ? "circle-exclamation" : "circle-check";
  const tooltipIconClass = isConflicted ? "oc-red-icon" : "oc-green-icon";

  return (
    <Button
      dataTestId={"dashboard-sync-plan-button"}
      modifier={"tool"}
      className={"oc-dashboard-header-button"}
      size={"small"}
      iconProps={{
        name: "arrows-rotate"
      }}
      iconOnly={true}
      disabled={isDisabled}
      tooltipProps={
        disabledTooltip
          ? {
              position: "bottom-end",
              message: disabledTooltip
            }
          : {
              position: "bottom-end",
              content: (
                <Flex gap={"8px"} direction={"column"}>
                  <DefaultTooltipContent {...getHoverTipContent("Sync plan")} />
                  <Flex alignItems={"center"} gap={"4px"}>
                    <span>
                      <Icon size={"xsmall"} name={statusIcon} className={tooltipIconClass} />
                    </span>
                    <Text size={"xsmall"} style={{ color: "#eeeeee" }}>
                      {planMgr?.GetLastSyncLabel()}
                    </Text>
                  </Flex>
                </Flex>
              )
            }
      }
      onClick={() => {
        wsMgr?.SyncPlan();
      }}
    />
  );
};
